import { axios, transformAxiosError } from "../utils/axios.create";
import { Action, ActionPayload } from "../domain/actions.interface";

export type ActionsFindAllPayload = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
  status: string;
  type: string;
};

const findAll = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
  type,
}: ActionsFindAllPayload): Promise<{
  list: Action[];
  totalCount: number;
}> => {
  const queryParams = new URLSearchParams({
    search,
    status,
    type,
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/actions/search?${queryParams.toString()}`)
    .then((res) => ({
      list: res.data.body.list as Action[],
      totalCount: res.data.body.totalCount as number,
    }))
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const createOne = async (payload: ActionPayload): Promise<Action> => {
  return axios
    .post("/actions", payload)
    .then((res) => res.data.body as Action)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const updateOne = async ({
  id,
  payload,
}: {
  id: string;
  payload: ActionPayload;
}): Promise<Action> => {
  return axios
    .put(`/actions/${id}`, payload)
    .then((res) => res.data.body as Action)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const archiveOne = async (id: string): Promise<void> => {
  return axios
    .delete(`/actions/${id}`)
    .then(() => undefined)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const ActionsService = {
  findAll,
  createOne,
  updateOne,
  archiveOne,
};
